import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const AwardStar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.95}
      d="M8.2 14.85v5.237c0 .83 0 1.247.262 1.378.263.132.595-.117 1.258-.616l1.14-.857c.55-.413.824-.619 1.14-.619s.591.206 1.14.62l1.14.856c.663.498.995.748 1.258.616.262-.131.262-.547.262-1.378V14.85m2.85-5.7a6.65 6.65 0 1 1-13.3 0 6.65 6.65 0 0 1 13.3 0m-6.964-3.599a.346.346 0 0 1 .629 0l.773 1.585a.36.36 0 0 0 .26.197l1.679.279c.285.047.399.412.195.625l-1.203 1.26a.38.38 0 0 0-.099.318l.265 1.758c.045.298-.253.523-.51.386l-1.514-.806a.34.34 0 0 0-.321 0l-1.516.806c-.256.137-.554-.088-.509-.386l.265-1.758a.38.38 0 0 0-.099-.318L8.78 8.238c-.204-.213-.09-.578.194-.625l1.68-.28a.35.35 0 0 0 .26-.196z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(AwardStar) as SvgIcon;
export { ForwardRef as ReactComponent };
